import React from "react";
import { useLocation } from "react-router-dom";

import {
  ProductContainer,
  ViewContainer,
  ContentContainer,
  SwitchRoutes,
  SubNav,
  StandaloneAppWrapper,
  BrandedDocumentTitle,
} from "@akj-dev/shared-components";

import { routes } from "./routes";

const AppStandaloneComponent = () => {
  const { pathname } = useLocation();

  return (
    <ProductContainer>
      <BrandedDocumentTitle title="Hub" />
      {pathname.includes(routes.rootPath) && (
        <SubNav routes={routes} rootTitle="Hub" />
      )}
      <ViewContainer>
        <ContentContainer>
          <SwitchRoutes routes={routes} />
        </ContentContainer>
      </ViewContainer>
    </ProductContainer>
  );
};

export const AppStandalone = () => (
  <StandaloneAppWrapper root={routes.rootPath}>
    <AppStandaloneComponent />
  </StandaloneAppWrapper>
);
